import { getLocalizedString } from "./I18n";
export function compareCountries(a, b) {
  return compareMultiLangString(a === null || a === void 0 ? void 0 : a.name, b === null || b === void 0 ? void 0 : b.name);
}
export function compareConnections(a, b) {
  var _a, _b, _c, _d, _e;
  const from = compareMultiLangString((_a = a === null || a === void 0 ? void 0 : a.stationFrom) === null || _a === void 0 ? void 0 : _a.name, (_b = b === null || b === void 0 ? void 0 : b.stationFrom) === null || _b === void 0 ? void 0 : _b.name);
  if (from) {
    return from;
  }
  const to = compareMultiLangString((_c = a === null || a === void 0 ? void 0 : a.stationTo) === null || _c === void 0 ? void 0 : _c.name, (_d = b === null || b === void 0 ? void 0 : b.stationTo) === null || _d === void 0 ? void 0 : _d.name);
  if (to) {
    return to;
  }
  return (_e = a === null || a === void 0 ? void 0 : a.trainNumber) === null || _e === void 0 ? void 0 : _e.localeCompare(b === null || b === void 0 ? void 0 : b.trainNumber);
}
export function compareMultiLangString(a, b) {
  const valueA = getLocalizedString(a);
  const valueB = getLocalizedString(b);
  if (!valueA && !valueB) {
    return 0;
  }
  else if (!valueA) {
    return -1;
  }
  else if (!valueB) {
    return 1;
  }
  else {
    return valueA.localeCompare(valueB);
  }
}
export function formatPrice(price, currency = '€') {
  return currency + ' ' + price.toFixed(2).replace('.', ',');
}
export function matchesStation(stop, station, country, carTransport) {
  return (!carTransport || stop.car)
    && (!station || station === stop.station.eva || station === stop.station.evaMeta)
    && (!country || country === stop.station.country);
}
export function matchesMultiLangString(value, query) {
  var _a, _b, _c, _d, _e, _f, _g;
  query = (_a = query === null || query === void 0 ? void 0 : query.trim()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
  return !query
    || ((_b = value === null || value === void 0 ? void 0 : value.int) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(query))
    || ((_c = value === null || value === void 0 ? void 0 : value.de) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(query))
    || ((_d = value === null || value === void 0 ? void 0 : value.en) === null || _d === void 0 ? void 0 : _d.toLowerCase().includes(query))
    || ((_e = value === null || value === void 0 ? void 0 : value.it) === null || _e === void 0 ? void 0 : _e.toLowerCase().includes(query))
    || ((_f = value === null || value === void 0 ? void 0 : value.fr) === null || _f === void 0 ? void 0 : _f.toLowerCase().includes(query))
    || ((_g = value === null || value === void 0 ? void 0 : value.nl) === null || _g === void 0 ? void 0 : _g.toLowerCase().includes(query));
}
export function getTicketshopEva(station) {
  return (station === null || station === void 0 ? void 0 : station.evaMeta) && station.evaMeta.length === 7 && !station.evaMeta.startsWith("00")
    ? station.evaMeta
    : station.eva;
}
export function getMetaEva(station) {
  return (station === null || station === void 0 ? void 0 : station.evaMeta) || (station === null || station === void 0 ? void 0 : station.eva);
}
//# sourceMappingURL=nightjet.js.map
